document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu-button]');
  const menuPanel = document.querySelector('[data-mobile-menu-panel]');
  if (menuButton && menuPanel) {
    menuButton.addEventListener('click', () => {
      const open = menuPanel.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
